import { UBILogger } from '@spotify-internal/ubi-logger-js/cjs/src';
import {
  NavigationEndInfo,
  NavigationStartInfo,
  UBIImpressionEvent,
  UBIInteractionEvent,
} from '@spotify-internal/ubi-types-js';

import { eventSender } from './eventSender';

export const createUbiLogger = (isLoggedIn: boolean) => {
  if (typeof window === 'undefined') {
    return {
      logImpression() {},
      logInteraction() {},
      logNavigationStart() {},
      logNavigationEnd() {},
    } as unknown as UBILogger;
  }
  const ubiLogger = new UBILogger({
    eventSender,
    disableAutoBackgroundMonitoring: true, // TODO: Make this work
  });

  // This is wrapping the currently used methods to adapt which function is used based on logged in state.
  return {
    logImpression: (event: UBIImpressionEvent): string =>
      isLoggedIn ? ubiLogger.logImpression(event) : ubiLogger.logNonAuthImpression(event),
    logInteraction: (event: UBIInteractionEvent): string =>
      isLoggedIn ? ubiLogger.logInteraction(event) : ubiLogger.logNonAuthInteraction(event),
    logNavigationEnd: (event: NavigationEndInfo) => ubiLogger.logNavigationEnd(event),
    logNavigationStart: (event: NavigationStartInfo) => ubiLogger.logNavigationStart(event),
  } as unknown as UBILogger;
};
